export default {
  name: 'OuterLink',
  props: {
    link: {
      type: String,
      default: '',
    },
    color: {
      type: String,
      default: 'blue',
    },
  },
};
